/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

import CardLong from '../../components/card-long'
import IcWhy from '../../static/icons/ic-why-massage.svg'
import IcHome from '../../static/icons/ic-home-massage.svg'
import IcClock from '../../static/icons/ic-clock-massage.svg'
import IcMap from '../../static/icons/ic-maps-massage.svg'
import { TitleOne, TextBodyOne } from '../../components/text'

import { Style } from './why-massage.styles'

const WhyHaloMassage = () => {
  const { t } = useTranslation();

  return (
    <Style id="why-massage">
      <Grid className="container-why-massage border-box-box-sizing" style={{ marginTop: 50 }}>
        <Row>
          <Col sm={12} xs={12} lg={12} style={{ marginBottom: 24 }}>
            <TitleOne display="block" align="center">
              {t('pageBodyMassageJakarta.part4')}
            </TitleOne>
            <TextBodyOne display="block" align="center">
              {t('pageBodyMassageJakarta.part5')}
            </TextBodyOne>

            <Fade left>
              <div className="page-line">
                <div />
              </div>
            </Fade>
          </Col>
        </Row>
        <Row>
          <Col
            sm={12}
            xs={12}
            lg={6}
            className="smaller-hover bottom"
          >
            <CardLong
              options={{
                image: IcWhy,
                title: t('pageBodyMassageJakarta.part6'),
                desc: t('pageBodyMassageJakarta.part7')
              }}
            ></CardLong>
          </Col>
          <Col
            sm={12}
            xs={12}
            lg={6}
            className="smaller-hover bottom"
          >
            <CardLong
              options={{
                image: IcHome,
                title: t('pageBodyMassageJakarta.part8'),
                desc: t('pageBodyMassageJakarta.part9')
              }}
            ></CardLong>
          </Col>
          <Col
            sm={12}
            xs={12}
            lg={6}
            className="smaller-hover bottom"
          >
            <CardLong
              options={{
                image: IcMap,
                title: t('pageBodyMassageJakarta.part10'),
                desc: t('pageBodyMassageJakarta.part11')
              }}
            ></CardLong>
          </Col>
          <Col
            sm={12}
            xs={12}
            lg={6}
            className="smaller-hover bottom"
          >
            <CardLong
              options={{
                image: IcClock,
                title: t('pageBodyMassageJakarta.part12'),
                desc: t('pageBodyMassageJakarta.part13')
              }}
            ></CardLong>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default WhyHaloMassage
